import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useScrollSpy = (routes) => {
  const [activeSection, setActiveSection] = useState("");
  const location = useLocation();

  useEffect(() => {
    // Hanya jalankan scroll spy jika sedang di halaman profile
    if (!location.pathname.includes("/profile")) {
      setActiveSection("");
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        // Collect all currently intersecting sections with their positions
        const intersectingSections = entries
          .filter((entry) => entry.isIntersecting)
          .map((entry) => ({
            id: entry.target.id,
            ratio: entry.intersectionRatio,
            top: entry.boundingClientRect.top,
            bottom: entry.boundingClientRect.bottom,
            element: entry.target,
          }));

        if (intersectingSections.length > 0) {
          // Sort by which section is more prominently visible
          intersectingSections.sort((a, b) => {
            // Prioritize sections that are more centered in viewport
            const aCenter = Math.abs(
              a.top + (a.bottom - a.top) / 2 - window.innerHeight / 2
            );
            const bCenter = Math.abs(
              b.top + (b.bottom - b.top) / 2 - window.innerHeight / 2
            );

            // If both sections are similarly centered, prefer the one with higher ratio
            if (Math.abs(aCenter - bCenter) < 100) {
              return b.ratio - a.ratio;
            }

            return aCenter - bCenter;
          });

          setActiveSection(intersectingSections[0].id);
        } else {
          // Fallback: manually determine active section based on scroll position
          const scrollPosition = window.scrollY + window.innerHeight / 3; // Use 1/3 of viewport as reference
          const sections = [];

          routes.forEach((route) => {
            if (route.path && route.path.includes("#")) {
              const hash = route.path.split("#")[1];
              const element = document.getElementById(hash);
              if (element) {
                sections.push({
                  id: hash,
                  top: element.offsetTop,
                  bottom: element.offsetTop + element.offsetHeight,
                });
              }
            }
          });

          sections.sort((a, b) => a.top - b.top);

          // Find which section the scroll position falls into
          let activeSection = "";
          for (let i = sections.length - 1; i >= 0; i--) {
            if (scrollPosition >= sections[i].top) {
              activeSection = sections[i].id;
              break;
            }
          }

          setActiveSection(activeSection || "");
        }
      },
      {
        rootMargin: "-30% 0px -30% 0px", // More aggressive margins to avoid multiple sections being active
        threshold: [0, 0.1, 0.3, 0.5, 0.7, 1],
      }
    );

    // Collect section IDs from routes
    const sectionIds = [];
    routes.forEach((route) => {
      if (route.path && route.path.includes("#")) {
        const hash = route.path.split("#")[1];
        if (hash) sectionIds.push(hash);
      }
    });

    // Observe elements
    sectionIds.forEach((id) => {
      const element = document.getElementById(id);
      if (element) {
        observer.observe(element);
      }
    });

    return () => observer.disconnect();
  }, [routes, location.pathname]);

  return activeSection;
};
